import {
  GET_BEARER_TOKEN_REQUEST,
  GET_BEARER_TOKEN_SUCCESS,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SET_BEARER_TOKEN_REQUEST,
  SET_BEARER_TOKEN_SUCCESS,
} from '../constants';

export interface IGetBearerTokenRequest {
  type: typeof GET_BEARER_TOKEN_REQUEST;
}

export interface ISetBearerTokenRequest {
  type: typeof SET_BEARER_TOKEN_REQUEST;
  bearerToken: string|null;
}

export interface ILogoutRequest {
  type: typeof LOGOUT_REQUEST;
}

export interface ILogoutSuccess {
  type: typeof LOGOUT_SUCCESS;
}

export interface ISetBearerTokenSuccess {
  type: typeof SET_BEARER_TOKEN_SUCCESS;
}

export interface IGetBearerTokenSuccess {
  type: typeof GET_BEARER_TOKEN_SUCCESS;
  bearerToken: string|null;
}

type ActionTypes = IGetBearerTokenSuccess;

const bearerToken = (state: string = '', action: ActionTypes): string => {
  switch (action.type) {
    case GET_BEARER_TOKEN_SUCCESS:
      return action.bearerToken || '';
    default:
      return state;
  }
};

export default bearerToken;
